module.exports = __webpack_public_path__ + "img/loader.c97a75c8.svg";